import React from "react";
import { Link } from "react-router-dom";
import { UserAuth } from "../context/AuthContext";
import { useLanguage } from "../context/LanguageContext";
import { translations } from "../translations";
import { getErrorMessage } from "../utils/errorMessages";

const Navbar = () => {
  const { user, logOut, deleteAccount, isProUser, reportCount, freeLimit, resetDate } = UserAuth();
  const { lang } = useLanguage();
  const T = translations[lang].navbar;

  const resetDateLabel = resetDate?.toLocaleDateString(
    lang === 'fr' ? 'fr-CA' : 'en-CA',
    { year: 'numeric', month: 'long', day: 'numeric', timeZone: 'UTC' }
  );

  const handleSignOut = async () => {
    try {
      await logOut();
      // Hard navigation (not a soft React-Router redirect) to a fresh page.
      // Firebase's popup sign-in loads gapi once per page session; after the
      // first popup, a second signInWithPopup leaves gapi in a stale state and
      // crashes inside Firebase (gapi.iframes undefined -> ".getContext" of
      // undefined), and the hung loader promise never recovers. Reloading the
      // page clears that state so the next Google sign-in works.
      window.location.assign("/signin");
    } catch (error) {
      console.log(error);
    }
  };

  const handleDeleteAccount = async () => {
    const confirmMessage = isProUser ? T.deleteAccountConfirmPro : T.deleteAccountConfirm;
    if (!window.confirm(confirmMessage)) {
      return;
    }
    try {
      await deleteAccount();
      // Same reasoning as handleSignOut: hard-reload so a subsequent Google
      // sign-in (e.g. creating a new account) starts on a fresh page.
      window.location.assign("/signin");
    } catch (error) {
      console.error(error);
      alert(getErrorMessage(error));
    }
  };

  return (
    <nav className="navbar">
      <div className="navbar-brand">
        <a href="https://aidify.ca/" target="_blank" rel="noopener noreferrer">
          <img
            src="/AidifyLogo.png"
            alt="Aidify Logo"
            className="navbar-logo"
          />
        </a>
      </div>
      <div className="navbar-end">
        {user?.displayName ? (
          <div className="navbar-user">
            <span className="navbar-welcome">
              {T.welcome(user.displayName)}
            </span>
            <div className="navbar-actions">
              {!isProUser && (
                <span className="navbar-usage" title={T.resetsOn(resetDateLabel)}>
                  {T.reportsUsed(reportCount, freeLimit)}
                </span>
              )}
              <Link to="/pricing" className="navbar-btn navbar-btn--upgrade">
                {isProUser ? T.billing : T.upgrade}
              </Link>
              <Link to="/shared-reports" className="navbar-btn navbar-btn--reports">
                {T.myReports}
              </Link>
              <button
                type="button"
                className="navbar-btn navbar-btn--logout"
                onClick={handleSignOut}
              >
                {T.logOut}
              </button>
              <button
                type="button"
                className="navbar-btn navbar-btn--delete"
                onClick={handleDeleteAccount}
              >
                {T.deleteAccount}
              </button>
            </div>
          </div>
        ) : (
          <Link to="/signin"></Link>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
